import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { ListProfileResponse } from '../../responses/user/list-profile.response';

@Injectable({
  providedIn: 'root'
})
export class ProfileService extends CommonService {

  constructor(private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) { super(configService); }

  public GetListByIdHealthUnit(idHealthUnit: number): Observable<ListProfileResponse> {

    let uri = `Profile/idHealthUnit/${idHealthUnit}`

    return this.httpClient.get<ListProfileResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiUser) + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}